

















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ProjectFileLink from '@/store/models/ProjectFileLink';

@Component({
  filters: {
    shortName(value: string): string {
      return value.replace('JavaScript', 'JS');
    },
    capitalize(value: string): string {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
})
export default class ProjectSettings extends Vue {
  @Prop({ type: Array as () => Array<ProjectFileLink>, required: true })
  private projects!: Array<ProjectFileLink>;

  @Prop({ type: Object as () => ProjectFileLink, required: true })
  private currentProject!: ProjectFileLink;

  private views: Array<string> = ['horizontal', 'vertical'];

  private currentSelectedView = 0;

  private chooseProject(project: string): void {
    this.$emit('choose-project', project);
  }

  private chooseView(value: number): void {
    this.currentSelectedView = value;
    this.$emit('choose-view', this.views[value]);
  }
}
